<c-card class="mb-4">
  <c-card-header>
    <div class="d-flex justify-content-between align-items-center">
      <h5>Total Investment</h5>
      <mat-form-field appearance="outline">
        <mat-label>Select Token</mat-label>
        <mat-select [(value)]="selectedToken">
          <mat-option *ngFor="let token of tokens" [value]="token">
            {{ token }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </c-card-header>

  <c-card-body>
    <div class="table-responsive">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Exchange</th>
            <th>Investment ({{ selectedToken }})</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let exchange of exchanges">
            <td>{{ exchange }}</td>
            <td>{{ getInvestment(exchange, selectedToken) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </c-card-body>
</c-card>
